import React from "react";
import Auth from "./auth/Auth";
import { Router, Route } from "react-router-dom";
import LoadingIndicator from "./components/utility/LoadingIndicator";
import { createBrowserHistory as createHistory } from "history";
import App from "./App";

const history = createHistory();

const auth = new Auth(history);

const handleAuthentication = (props: any) => {
  const location = props.location;
  if (/access_token|id_token|error/.test(location.hash)) {
    auth.handleAuthentication();
  }
};

export const makeAuthRouting = () => {
  return (
    <Router history={history}>
      <div>
        <Route
          path='/callback'
          render={(props) => {
            handleAuthentication(props);
            return <LoadingIndicator message='Loading Application' />;
          }}
        />
        <Route
          render={(props) => {
            return <App auth={auth} {...props} />;
          }}
        />
      </div>
    </Router>
  );
};
